export default "__VITE_ASSET__DWhKh9Tt__"